<script>
    import { answer, hangup, transfer, mute, hold } from '../../domain/call/telephony.actions';
    import { getTeamMembers as GetTeamMembers } from '../../domain/session/profile.action';
    import { CALL_STATE_CONSTANTS, parseMobile, pickOutInitials } from '../../services/utils';
    import { getContacts as GetContacts } from '../../domain/call/contact.action';
    import ButtonRounded from '../../common/ButtonRounded.svelte';
    import InfiniteScroll from 'svelte-infinite-scroll';
    import Icon from '../../components/Icon.svelte';
    import { formatDuration } from 'services/utils';
    import { useNavigate } from 'svelte-navigator';
    import contactStore from '../../store/contact';
    import sessionStore from 'store/session';
    import toast from '../../services/toast';
    import { fly } from 'svelte/transition';
    import { backOut } from 'svelte/easing';
    import callStore from 'store/call';
    import { onMount } from "svelte";

    const navigate = useNavigate();

    let show_transfer;
    let team_members = [];
    let total_page = 1;
    let page = 1;
    let loading = false;
    
    const ring = new Audio('https://outlinks.pressone.co/p0p');

    $: {
        if (
            $callStore.state === CALL_STATE_CONSTANTS.INCALL ||
            $callStore.state === CALL_STATE_CONSTANTS.OUTCALL ||
            $callStore.state === CALL_STATE_CONSTANTS.IDLE
        ) {
            if (!ring.paused) {
                ring.pause();
                ring.currentTime = 0;
            }
        }
    }

    $: {
        if (
            $callStore.state === CALL_STATE_CONSTANTS.IDLE
        ) {
            navigate("/")
        }
    }

    $: {
        if (
            $callStore.state === CALL_STATE_CONSTANTS.RINGING
        ) {
            ring.play()
        }
    }

    $: {
        if ( $callStore.peer ) {
            if ($contactStore.contacts.length === 0) {
                loadMoreContacts().then(() => {
                    findContact()
                })
            } else {
                findContact()
            }
        }
    }

    const findContact = () => {
        
        try {
            const { name } = $contactStore.contacts.find(({number}) => parseMobile(number) === parseMobile($callStore.peer))
            if (name) {
                callStore.update({
                    peerName: name,
                    peerInitials: pickOutInitials(name) 
                })
            }
        } catch(_){}
    }

    const toggleMute = () => {
        if ($callStore.microphone) {
            mute(false);
            toast.success('call unmute')
        } else {
            mute(true);
            toast.success('call muted')
        }
    };

    const toggleHold = () => {
        if ($callStore.hold) {
            hold(false);
            toast.success('Call released')
        } else {
            hold(true)
            toast.success('Call on hold')
        }
    };

    const toggleTransfer = () => {
        show_transfer = !show_transfer
    }

    const loadMoreTeamMembers = async (page = 1) => {
        loading = true
        try {
            const { data, nb_pages, page_size, page_index } = await GetTeamMembers($sessionStore.profile.business.id, page)
            team_members = [
                ...team_members,
                ...data
            ]
            total_page = nb_pages
            page = page_index
        } catch (error) {
            console.log(error)
        } finally {
            loading = false
        }
    }

    const loadMoreContacts = async () => {
        try {
            const { data, nb_pages, page_index } = await GetContacts($sessionStore.profile.business.id, $contactStore.page+1)
            contactStore.updateContact(data)
            contactStore.update({
                page: page_index,
                total_page: nb_pages
            })
        } catch (error) {
            console.log(error)
        }
    }

    const showNote = () => {
        callStore.update({
            takeNote: true
        })
    }

    const addToContact = () => {
        callStore.update({
            minimize: true
        });
        navigate("/add-contact", {state: {number: $callStore.peer}})
    }

    onMount( async () => {
        await loadMoreTeamMembers()
    })

</script>

<div class="flex h-screen w-full">
    <section class="flex flex-col w-full h-full justify-center items-center">
        <div class="absolute top-6 left-6 rounded-full p-1 flex bg-red-100">
            <Icon icon="record" /> <span class="text-red-900 ml-1">{formatDuration($callStore.duration)}</span>
        </div>
        <div class="bg-gray-400 w-20 h-20 rounded-full flex justify-center items-center mt-1">
            {#if $callStore.peerInitials}
                { $callStore.peerInitials }
            {:else if $callStore.peerName}
                { pickOutInitials($callStore.peerName) }
            {:else}
                <Icon icon="call-avatar" size="30" />
            {/if}
        </div>
        <div class="primary-text-color text-lg text-center mb-1 mt-4">{ $callStore.peerName || $callStore.peer }</div>
        {#if $callStore.duration > 0}
            <div class="text-green-600 text-sm text-center mb-10">{formatDuration($callStore.duration)}</div>
        {:else}
            <div class="text-green-600 text-sm text-center mb-10 animate-flicker">{$callStore.state}...</div>
        {/if}
        <!-- <div class="{[
                CALL_STATE_CONSTANTS.IDLE,
                CALL_STATE_CONSTANTS.OUTCALL, 
                CALL_STATE_CONSTANTS.INCALL, 
                CALL_STATE_CONSTANTS.RINGING
            ].includes($callStore.state) ? 'gap-2' : 'gap-8'} flex items-center justify-center"> -->
        <div class="grid gap-x-8 gap-y-4 grid-cols-3">
            {#if $callStore.state === CALL_STATE_CONSTANTS.RINGING}
            <div class="">
                <ButtonRounded
                    on:click={answer}
                    size="12"
                    title=""
                    icon="ringing-filled"
                    iconColor="#fff"
                    iconSize=24
                    className="bg-green-500 w-12 h-12"
                />
                <span class="block mt-1 text-gray-400 text-center text-sm">Receive</span>
            </div>
            {/if}
            {#if [
                    // CALL_STATE_CONSTANTS.IDLE,
                    CALL_STATE_CONSTANTS.OUTCALL, 
                    CALL_STATE_CONSTANTS.INCALL, 
                    CALL_STATE_CONSTANTS.OUTGOING
                ].includes($callStore.state)
            }
            <div class="">
                <ButtonRounded
                    on:click={toggleHold}
                    size="12"
                    title=""
                    icon={$callStore.hold ? "hands" : "speaker"}
                    iconColor={$callStore.hold ? '#EF3333' : '#474B50'}
                    iconSize=24
                    className="bg-gray-100 w-12 h-12"
                />
                <span class="block mt-1 text-gray-400 text-center text-sm">{$callStore.hold ? 'UnHold' : 'Hold'}</span>
            </div>
            {/if}
            {#if [
                    // CALL_STATE_CONSTANTS.IDLE,
                    CALL_STATE_CONSTANTS.OUTCALL, 
                    CALL_STATE_CONSTANTS.INCALL, 
                    CALL_STATE_CONSTANTS.OUTGOING
                ].includes($callStore.state)
            }
            <div class="">
                <ButtonRounded
                    on:click={toggleMute}
                    size="12"
                    title=""
                    icon={$callStore.microphone ? 'microphone' : 'microphone-mute'}
                    iconColor={$callStore.microphone ? '#474B50' : '#EF3333'}
                    iconSize=24
                    className="bg-gray-100 w-12 h-12 {$callStore.microphone ? '' : 'bg-gray-700'}"
                />
                <span class="block mt-1 text-gray-400 text-center text-sm">{$callStore.microphone ? 'Mute' : 'Un-mute'}</span>
            </div>
            {/if}
            {#if 
                [
                    // CALL_STATE_CONSTANTS.IDLE,
                    CALL_STATE_CONSTANTS.OUTCALL, 
                    CALL_STATE_CONSTANTS.INCALL, 
                    CALL_STATE_CONSTANTS.RINGING
                ].includes($callStore.state)
            }
            <div class="">
                <ButtonRounded
                    on:click={toggleTransfer}
                    size="12"
                    title=""
                    icon="transfer"
                    iconSize=24
                    iconColor="#475367"
                    className="bg-gray-100 w-12 h-12"
                />
                <span class="block mt-1 text-gray-400 text-center text-sm">Transfer</span>
            </div>
            {/if}
            {#if [
                    // CALL_STATE_CONSTANTS.IDLE,
                    CALL_STATE_CONSTANTS.OUTCALL, 
                    CALL_STATE_CONSTANTS.INCALL, 
                    CALL_STATE_CONSTANTS.OUTGOING
                ].includes($callStore.state)
            }
            <div class="">
                <ButtonRounded
                    on:click={showNote}
                    size="12"
                    title=""
                    icon="message"
                    iconColor="#475367"
                    iconSize=24
                    className="bg-gray-100 w-12 h-12"
                />
                <span class="block mt-1 text-gray-400 text-center text-sm">Note</span>
            </div>
            {/if}
            {#if $callStore.state === CALL_STATE_CONSTANTS.OUTCALL}
            <div class="">
                <ButtonRounded
                    on:click={hangup}
                    size="12"
                    title=""
                    icon="cancel"
                    iconColor="#fff"
                    iconSize=24
                    className="bg-red-600 w-12 h-12"
                />
                <span class="block mt-1 text-gray-400 text-center text-sm">Cancel</span>
            </div>
            {/if}
            {#if [
                    // CALL_STATE_CONSTANTS.IDLE,
                    CALL_STATE_CONSTANTS.RINGING, 
                    CALL_STATE_CONSTANTS.INCALL, 
                    CALL_STATE_CONSTANTS.OUTGOING
                ].includes($callStore.state)
            }
            <div class="">
                <ButtonRounded
                    on:click={hangup}
                    size="12"
                    title=""
                    icon="end-call"
                    iconColor="#fff"
                    iconSize=24
                    className="bg-red-600 w-12 h-12"
                />
                <span class="block mt-1 text-gray-400 text-center text-sm">End</span>
            </div>
            {/if}

            {#if 
                [
                    // CALL_STATE_CONSTANTS.IDLE,
                    CALL_STATE_CONSTANTS.OUTCALL, 
                    CALL_STATE_CONSTANTS.INCALL, 
                    CALL_STATE_CONSTANTS.RINGING
                ].includes($callStore.state)
            }
            <div class="">
                <ButtonRounded
                    on:click={addToContact}
                    size="12"
                    title=""
                    icon="plus"
                    iconSize=24
                    iconColor="#475367"
                    className="bg-gray-100 w-12 h-12"
                />
                <span class="block mt-1 text-gray-400 text-center text-sm">Add</span>
            </div>
            {/if}
        </div>
        <div class="relative w-full z-20">
            <div class="absolute w-full" style="top: -75px;">
                {#if show_transfer && 
                    [
                        // CALL_STATE_CONSTANTS.IDLE,
                        CALL_STATE_CONSTANTS.OUTCALL, 
                        CALL_STATE_CONSTANTS.INCALL, 
                        CALL_STATE_CONSTANTS.RINGING
                    ].includes($callStore.state)
                }
                <div class="flex flex-col overflow-y-scroll mx-4 rounded-lg  p-4 shadow-2xl bg-white" style="max-height: 21vh;"
                    in:fly={{
                        y: -100,
                        delay: 100,
                        easing: backOut
                  }}
                >
                    <ul>
                        {#each team_members as member}
                            {#each member.receivers as receiver}
                                {#if $sessionStore.receiver.business_number.id === receiver.business_number}
                                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                                    <li class="flex justify-between py-2" on:click={() => transfer(receiver.extension_code)}>
                                        <div class="flex">
                                            <div class="flex justify-center items-center bg-gradient-to-r from-green-400 to-blue-500 rounded-full h-6 w-6 text-white text-xs">
                                                { pickOutInitials(`${ member.first_name } ${ member.last_name }`) }
                                            </div>
                                            <div class="flex text-gray-900 ml-2 text-xs">
                                                { member.first_name } { member.last_name }
                                            </div>
                                        </div>
                                        <div>
                                            <input type="radio" name="business_selection" />
                                        </div>
                                    </li>
                                {/if}
                            {/each}
                        {/each}
                        {#if loading}
                        <div class="flex justify-center items-center h-4/6" style="height: 16rem;">
                            <Icon icon="loader" />
                            <i class="animate-pulse">loading record...</i>
                        </div>
                        {/if}
                    </ul>
                    <InfiniteScroll
                        hasMore={page < total_page}
                        threshold={3}
                        on:loadMore={() => loadMoreTeamMembers(page+1)}
                    />
                </div>
                {/if}
            </div>
        </div>
    </section>
    <div class="flex absolute left-0 right-0 bottom-0 h-2 bg-sky-500"></div>
</div>

<style>
    .primary-text-color {
        color: var(--primary-text-color)
    }
</style>